module.exports = __webpack_public_path__ + "static/pic41-627a24679cb5997a8ddf60a0590b496d.png";